
























import { Component, Vue } from 'vue-property-decorator';
import { MedTransGoConstants } from '@/util/constants';

@Component({
    props: {
        serviceRequest: Object,
    },
})
export default class OverlapRequestMessageModal extends Vue {
    private show = false;

    public mounted() {
        this.show = true;
    }

    private async gotoRequest() {
        this.$router.push({
            path: `${MedTransGoConstants.URL_REQUESTS}/${this.$props.serviceRequest.id}`,
            query: { requestType: 'interpreterRequest' },
        });
        this.show = false;
        this.$emit('close');
    }

    private close() {
        this.show = false;
        this.$emit('close');
    }
}
